var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual', {
    attrs: {
      "sh": "인재채용",
      "tabActive": "현직자 인터뷰",
      "bg": "/images/sub/visual/sv4-5.jpg"
    }
  }), _c('div', {
    staticClass: "text-center color-white bg-point py-50 py-lg-74 w-100"
  }, [_c('v-container', [_c('h3', {
    staticClass: "tit font-weight-bold font-italic",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("도전하는 사람들의 이야기 ")])]), _c('p', {
    staticClass: "tit-txt mt-10 mt-lg-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 세일즈웍스 코리아와 함께하는 사람들의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 생생한 이야기를 들어보세요. ")])])], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('manager-interview', {
    staticClass: "mb-50 mb-lg-100"
  }), _c('branch-interview', {
    staticClass: "mb-50 mb-lg-100"
  }), _c('head-interview', {
    staticClass: "mb-50 mb-lg-100"
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }